import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";
import moment from "moment";
import _ from "lodash";

export const state = {
  projects: [],
  project: {},
  project_overview_amount: {},
  getEmployees: [],
  projectLifeTime: '',
  listKickOffBonus: [],
  listKickOffBonusDates: {},
  kickOffBonusInfo: null,
  listProjectMember: [],
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  employees: [],
  customers: [],
  employee_position: [],
  project_status: [],
  project_info: [],
  listResourceSituations: [],
  resourceSituationChart: [],
  employeeSkill: [],
  reviews: [],
  haveReviews: false,
  positions: [],
  customerList: [],
  contract_management: [],
  newKickOff: null,
  totalResourceSituations: 0,
  resourceStatistics: [],
  resourceDivisionStatistics: [],
  resourceEffortStatistics: [],
  resourceEffortDayValues: {},
  resourceEffortColors: {},
  resourceEffortDates: {
    startDate: moment().subtract(18, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  projectStatusStatistics: [],
  projectStatusStatisticsTooltip: null,
  personChargeProjects: [],
  dataMMYear: [],
  personInChargeManmonth: null
};

// getters
export const getters = {
  projects: state => state.projects,
  pagination: state => state.pagination,
  project: state => state.project,
  project_overview_amount: state => state.project_overview_amount,
  projectLifeTime: state => state.projectLifeTime,
  listKickOffBonus: state => state.listKickOffBonus,
  listKickOffBonusDates: state => state.listKickOffBonusDates,
  kickOffBonusInfo: state => state.kickOffBonusInfo,
  listProjectMember: state => state.listProjectMember,
  getEmployees: state => state.getEmployees,
  employees: state => state.employees,
  customers: state => state.customers,
  employee_position: state => state.employee_position,
  project_info: state => state.project_info,
  project_status: state => state.project_status,
  listResourceSituations: state => state.listResourceSituations,
  resourceSituationChart: state => state.resourceSituationChart,
  employeeSkill: state => state.employeeSkill,
  reviews: state => state.reviews,
  haveReviews: state => state.haveReviews,
  positions: state => state.positions,
  contract_management: state => state.contract_management,
  newKickOff: state => state.newKickOff,
  totalResourceSituations: state => state.totalResourceSituations,
  resourceStatistics: state => state.resourceStatistics,
  resourceDivisionStatistics: state => state.resourceDivisionStatistics,
  resourceSEStatistics: state => state.resourceSEStatistics,
  resourceEffortStatistics: state => state.resourceEffortStatistics,
  resourceEffortDayValues: state => state.resourceEffortDayValues,
  resourceEffortColors: state => state.resourceEffortColors,
  resourceEffortDates: state => state.resourceEffortDates,
  projectStatusStatistics: state => state.projectStatusStatistics,
  projectStatusStatisticsTooltip: state => state.projectStatusStatisticsTooltip,
  personChargeProjects: state => state.personChargeProjects,
  dataMMYear: state => state.dataMMYear,
  personInChargeManmonth: state => state.personInChargeManmonth,
};

// mutations
export const mutations = {
  [types.PROJECT.FETCH_PROJECT](state, projects) {
    state.projects = projects;
    state.pagination.from = projects.from;
    state.pagination.to = projects.to;
    state.pagination.totalPage = projects.last_page;
    state.pagination.path = projects.path;
    state.pagination.currentPage = projects.current_page;
    state.pagination.totalRecord = projects.total;
    state.pagination.perPage = projects.per_page;
  },
  [types.PROJECT.PROJECT_DETAIL](state, project) {
    state.project = project;
    const startDate = moment(project.start_date, "DD-MM-YYYY");
    const endDate = moment(project.end_date, "DD-MM-YYYY");
    state.projectLifeTime = endDate.diff(startDate, 'days');
  },
  [types.PROJECT.SET_RESOURCE_START_END_DATE](state, payload) {
    state.resourceEffortDates.startDate = payload.start_date;
    state.resourceEffortDates.endDate = payload.end_date;
  },
  [types.PROJECT.GET_EMPLOYEE](state, getEmployees) {
    state.getEmployees = getEmployees;
  },
  [types.PROJECT.EMPLOYEES](state, employees) {
    state.employees = employees;
  },
  [types.PROJECT.CUSTOMERS](state, customers) {
    state.customers = customers;
  },
  [types.PROJECT.EMPLOYEE_POSITION](state, employee_position) {
    state.employee_position = employee_position;
  },
  [types.PROJECT.GET_DETAIL_PROJECT](state, res) {
    state.project = res;
  },
  [types.PROJECT.PROJECT_STATUS](state, res) {
    state.project_status = res;
  },
  [types.PROJECT.FETCH_RESOURCE_SITUATION](state, projects) {
    state.listResourceSituations = projects;
  },
  [types.PROJECT.RESOURCE_SITUATION_CHART](state, projects) {
    state.resourceSituationChart = projects;
  },
  [types.PROJECT.TOTAL_RESOURCE_SITUATIONS](state, projects) {
    state.totalResourceSituations = projects;
  },
  [types.PROJECT.GET_EMPLOYEE_SKILL](state, projects) {
    state.employeeSkill = projects;
  },
  [types.PROJECT.SET_LIST_KICK_OFF_BONUS](state, payload) {
    if (payload && payload.length > 0) {
      state.listKickOffBonus = payload;
      let listKickOffBonusDates = {};
      payload.map((value, index) => {
        if (value.date) {
          const dateC = moment(value.date, "YYYY-MM-DD hh:mm:ss");
          const date = moment(value.date, "YYYY-MM-DD hh:mm:ss").format('DD/MM/YYYY');
          const startDate = moment(state.project.start_date, "DD/MM/YYYY");
          const distantDateWithStart = dateC.diff(startDate, 'days');
          if (!listKickOffBonusDates[date]) {
            listKickOffBonusDates[date] = {};
            listKickOffBonusDates[date].distant = distantDateWithStart;
            listKickOffBonusDates[date].index = 0;
            listKickOffBonusDates[date].list = [];
          }
          listKickOffBonusDates[date].list.push(index);
        }
      });
      state.listKickOffBonusDates = listKickOffBonusDates;
    } else {
      state.listKickOffBonusDates = {};
      state.listKickOffBonus = [];
    }
  },
  [types.PROJECT.SET_RESOURCE_STATISTICS](state, data) {
    state.resourceStatistics = data;
  },
  [types.PROJECT.SET_RESOURCE_DIVISION_STATISTICS](state, data) {
    state.resourceDivisionStatistics = data;
  },
  [types.PROJECT.SET_RESOURCE_SE_STATISTICS](state, data) {
    state.resourceSEStatistics = data;
  },
  [types.PROJECT.SET_RESOURCE_EFFORT_STATISTICS](state, data) {
    state.resourceEffortStatistics = data;
    let resourceEffortDayValues = {};
    let resourceEffortColors = {};
    Object.keys(data).map(key => {
      const dataId = data[key].id;
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      resourceEffortColors[dataId] = color;
      Object.keys(data[key].efforts).map(effortKey => {
        const value = String(data[key].efforts[effortKey].effort);
        const isCreated = String(data[key].efforts[effortKey].is_created);
        if (!resourceEffortDayValues[effortKey]) {
          resourceEffortDayValues[effortKey] = {};
        }
        if (!resourceEffortDayValues[effortKey][value]) {
          resourceEffortDayValues[effortKey][value] = [{
            name: data[key].name,
            id: data[key].id,
            value: value,
            is_created: isCreated
          }];
        } else {
          resourceEffortDayValues[effortKey][value].push({
            name: data[key].name,
            id: data[key].id,
            value: value,
            is_created: isCreated
          });
        }
      });
    });
    state.resourceEffortColors = resourceEffortColors;
    state.resourceEffortDayValues = resourceEffortDayValues;
  },
  // [types.PROJECT.SET_LIST_KICK_OFF_BONUS](state, payload) {
  //   state.kickOffBonusInfo = payload;
  // },
  [types.PROJECT.SET_LIST_PROJECT_MEMBER](state, payload) {
    state.listProjectMember = payload;
  },
  [types.PROJECT.SET_REVIEWS](state, payload) {
    const { data, status } = payload;
    if (status === 200) {
      if (data) {
        let reviews = data;
        Object.keys(reviews).map((key) => {
          const startDate = moment(reviews[key].start_date).format("DD/MM/YYYY");
          const endDate = moment(reviews[key].end_date).format("DD/MM/YYYY");
          reviews[key].week_day = startDate + ' - ' + endDate;
          reviews[key].updated_at = moment(reviews[key].updated_at).format("DD/MM/YYYY");
        });
        const startDayCurrent = moment(new Date()).startOf("isoWeek").format("YYYY-MM-DD");
        if (!reviews[startDayCurrent]) {
          reviews[startDayCurrent] = {
            note: null,
            index: 1,
            project_id: payload.id,
            project_overview_items: {
              communication: 1,
              personnel: 1,
              progress: 1,
              quality: 1,
              schedule: 1,
              scope: 1,
              skill: 1,
              tech: 1,
            }
          };
        }
        state.reviews = reviews;
        state.haveReviews = true;
      } else {
        let reviews = {};
        const startDayCurrent = moment(new Date()).startOf("isoWeek").format("YYYY-MM-DD");
        reviews[startDayCurrent] = {
          note: null,
          index: 1,
          project_id: payload.id,
          project_overview_items: {
            communication: 1,
            personnel: 1,
            progress: 1,
            quality: 1,
            schedule: 1,
            scope: 1,
            skill: 1,
            tech: 1,
          }
        };
        state.reviews = reviews;
        state.haveReviews = false;
      }
    }
  },
  [types.PROJECT.SET_CONTRACT_HISTORY](state, payload) {
    const { data } = payload;
    state.contract_management = data;
  },
  SET_NEW_KICKOFF(state, payload) {
    state.newKickOff = payload;
  },
  [types.PROJECT.SET_PROJECT_STATUS_STATISTICS](state, data) {
    state.projectStatusStatistics = data;
  },
  [types.PROJECT.SET_PROJECT_STATUS_TOOLTIP_STATISTICS](state, data) {
    state.projectStatusStatisticsTooltip = data;
  },
  [types.PROJECT.SET_PROJECT_OVERVIEW_AMOUNT](state, payload) {
    state.project_overview_amount = payload;
  },
  [types.PROJECT.SET_PERSON_CHARGE_PROJECTS](state, data) {
    state.personChargeProjects = data;
  },
  [types.PROJECT.SET_DATA_MM](state, data) {
    state.dataMMYear = data;
  },
  [types.PROJECT.SET_PERSON_IN_CHARGE_MANMONTH](state, data) {
    state.personInChargeManmonth = data;
  },
};

// actions
export const actions = {
  async fetchProject({ commit }, payload) {
    const response = await axios.get(api.LIST_PROJECT, {
      params: {
        name: payload.name,
        status: payload.status,
        project_type: payload.project_type,
        department_test: payload.department_test,
        department_code: payload.department_code
      }
    });
    commit(types.PROJECT.FETCH_PROJECT, response.data.projects);
  },
  async getOverviewProjectAmount({ commit }) {
    const response = await axios.get(api.PROJECT_MANAGEMENT.OVERVIEW_PROJECTS);
    commit(types.PROJECT.SET_PROJECT_OVERVIEW_AMOUNT, response.data);
  },
  async showDetail({ commit }, id) {
    const response = await axios.get(api.LIST_PROJECT + "/" + id);
    commit(types.PROJECT.PROJECT_DETAIL, response.data);
  },
  async setStartEndDate({ commit }, payload) {
    commit(types.PROJECT.SET_RESOURCE_START_END_DATE, payload);
  },
  // eslint-disable-next-line
  async delete({ commit }, data) {
    let url = `${api.LIST_PROJECT}/delete/${data}`;
    await axios.post(url);
  },
  async getEmployeeAll({ commit }) {
    let url = `${api.LIST_PROJECT}/employee`;
    const response = await axios.get(url);
    commit(types.PROJECT.GET_EMPLOYEE, response.data.employees);
  },
  async getCustomerList({ commit }) {
    let url = `${api.LIST_PROJECT_CUSTOMERS}`;
    const response = await axios.get(url);
    commit(types.PROJECT.CUSTOMERS, response.data);
  },
  async getCommonsData({ commit }) {
    const response = await axios.get(api.GET_COMMON_PROJECT);
    commit(types.PROJECT.EMPLOYEES, response.data.employees);
    commit(types.PROJECT.CUSTOMERS, response.data.customers);
    commit(types.PROJECT.PROJECT_STATUS, response.data.project_status);
    commit(types.PROJECT.EMPLOYEE_POSITION, response.data.employee_position);
  },
  // eslint-disable-next-line
  async createProject({ commit }, params) {
    await axios.post(api.CREATE_PROJECT, params);
  },

  async getEmployeeSkill({ commit }, params) {
    let url = `${api.GET_EMPLOYEE_SKILL}/${params}`;
    try {
      const response = await axios.get(url);
      commit(types.PROJECT.GET_EMPLOYEE_SKILL, response.data.employee_skill);
      return response;
    } catch (e) {
      return e.response;
    }
  },
  async getInfoProject({ commit }, params) {
    let url = `${api.GET_DETAIL_PROJECT}/${params}/edit`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status === 200) {
      commit(types.PROJECT.GET_DETAIL_PROJECT, response.data);
    }
  },

  // eslint-disable-next-line
  async updateEmployee({ commit }, params) {
    let url = `${api.UPDATE_PROJECT}/${params.id}`;
    await axios.post(url, params);
  },

  async listResourceSituations({ commit }, payload) {
    const response = await axios.get(api.LIST_RESOURCE_SITUATION, {
      params: {
        employee_info: payload.employeeInfo,
        status: payload.status,
        footCode: payload.footCode,
        division: payload.division,
        start_date: payload.start_date,
        end_date: payload.end_date,
        active_tab: payload.activeTab,
        skill: payload.skill,
        sort_column: "department_code",
        sort_by: "asc",
        page: payload.page
      }
    });
    commit(
      types.PROJECT.FETCH_RESOURCE_SITUATION,
      response.data.resourceSituations
    );
    commit(
      types.PROJECT.RESOURCE_SITUATION_CHART,
      response.data.chartResourceSituation
    );
    commit(
      types.PROJECT.TOTAL_RESOURCE_SITUATIONS,
      response.data.totalResourceSituations
    );
  },
  async getListKickOffBonus({ commit }, projectId) {
    const response = await axios.get(`/api/project-management/${projectId}/kickoff-and-bonus`).then((res) => res.data);
    commit(types.PROJECT.SET_LIST_KICK_OFF_BONUS, response);
  },
  async getListProjectMember({ commit }, projectId) {
    const response = await axios.get(`/api/project-management/${projectId}/activity/get-project-member`).then((res) => res.data);
    commit(types.PROJECT.SET_LIST_PROJECT_MEMBER, response);
  },
  async getReviews({ commit }, payload) {
    const { id } = payload;
    let url = api.REVIEWS.replace(":id", id);
    let response = await axios.get(url.replace(":id", id));
    response.id = id;
    commit(types.PROJECT.SET_REVIEWS, response);
  },
  async postReviews(_, payload) {
    const { id, formData } = payload;
    const response = await axios.post(api.REVIEWS.replace(":id", id), formData);
    return response;
  },
  async getContractManagement({ commit }, payload) {
    const { id } = payload;
    let url = api.PROJECT_MANAGEMENT.CONTRACT_HISTORY.replace(":id", id);
    let response = await axios.get(url.replace(":id", id));
    commit(types.PROJECT.SET_CONTRACT_HISTORY, response);
  },
  async postContractHistory(_, formData) {
    const response = await axios.post(api.PROJECT_MANAGEMENT.CREATE_CONTRACT_HISTORY, formData);
    return response;
  },
  async updateContractHistory(_, formData) {
    const response = await axios.post(api.PROJECT_MANAGEMENT.UPDATE_CONTRACT_HISTORY, formData);
    return response;
  },
  async delContractHistory(_, id) {
    let response = await axios.delete(api.PROJECT_MANAGEMENT.CONTRACT_HISTORY.replace(":id", id));
    return response;
  },
  async createActivity({ commit }, params) {
    let projectId = params.get('project_id');
    const response = await axios
      .post(`/api/project-management/${projectId}/activity`, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res.data)
      .catch((err) => err.response.data);
    commit("SET_NEW_KICKOFF", response);
  },
  async updateProjectDetail(_, { data, id }) {
    const response = await axios.post(api.UPDATE_PROJECT + "/" + id, data);
    return response;
  },
  async getListEmployee({ commit }) {
    const response = await axios.get(api.GET_COMMON_EMPLOYEES)
    commit(types.PROJECT.EMPLOYEES, response.data)
  },
  async getResourceStatistics({ commit }, { code }) {
    const response = await axios.get(api.GET_RESOURCE_STATISTICS, { params: { department_code: code } });
    commit(types.PROJECT.SET_RESOURCE_STATISTICS, response.data)
    return response.data;
  },
  async getResourceDivisionStatistics({ commit }, { code }) {
    const response = await axios.get(api.GET_RESOURCE_DIVISION_STATISTICS, { params: { code: code } });
    commit(types.PROJECT.SET_RESOURCE_DIVISION_STATISTICS, response.data);
    return response.data;
  },
  async getResourceSEStatistics({ commit }) {
    const response = await axios.get(api.GET_RESOURCE_SE_STATISTICS);
    commit(types.PROJECT.SET_RESOURCE_SE_STATISTICS, response.data);
  },
  async getResourceEffortStatistics({ commit }, { params }) {
    const response = await axios.get(api.GET_RESOURCE_EFFORT_STATISTICS, { params: params });
    commit(types.PROJECT.SET_RESOURCE_EFFORT_STATISTICS, response.data);
  },
  async getProjectStatusStatistics({ commit }) {
    const response = await axios.get(api.GET_PROJECT_STATUS_STATISTICS);
    commit(types.PROJECT.SET_PROJECT_STATUS_STATISTICS, response.data);
    commit(types.PROJECT.SET_PROJECT_STATUS_TOOLTIP_STATISTICS,
        response.data.project_list);
  },
  async getDataMMYear({commit}, {params}) {
    const response = await axios.get(api.GET_DATA_MM_YEAR, {params: params});
    commit(types.PROJECT.SET_DATA_MM, response.data);
  },
  async getPersonChargeProjects({ commit }, payload) {
    const params = {
      month: payload.month
    }
    if (payload.division) {
      params.division = payload.division;
    }
    const response = await axios.get(api.GET_PROJECT_CHARGE_PROJECTS, { params });
    commit(types.PROJECT.SET_PERSON_CHARGE_PROJECTS, response.data);
  },

  async getPersonInChargeManmonth({ commit }, params) {
    const response = await axios.get(api.GET_PROJECT_IN_CHARGE_MANMONTH, { params });
    commit(types.PROJECT.SET_PERSON_IN_CHARGE_MANMONTH, response.data);
  },
};
